import { TeamPage } from "./team";

export const pages = {
  "companies.team": TeamPage,
};
